import common from './en-US/common';
import datasets from './en-US/datasets';
import datasetsDetail from './en-US/datasets.detail';
import docs from './en-US/docs';
import feedback from './en-US/feedback';
import footer from './en-US/footer';
import home from './en-US/home';
import material from './en-US/material';
import nav from './en-US/nav';
import user from './en-US/user';
import applyDownload from './en-US/applydownload';
import downloadModal from './en-US/download-modal';
import guide from './en-US/guide';
import aboutUs from './en-US/aboutUs';
import modelscope from './en-US/modelscope';
import extractor from './en-US/extractor';
import smallLanguageEn from './en-US/small-language';
import wanjuan from './en-US/wanjuan';

export default {
  ...common,
  ...nav,
  ...footer,
  ...user,
  ...home,
  ...datasets,
  ...datasetsDetail,
  ...docs,
  ...feedback,
  ...material,
  ...applyDownload,
  ...downloadModal,
  ...guide,
  ...aboutUs,
  ...modelscope,
  ...extractor,
  ...smallLanguageEn,
  ...wanjuan,
};
